import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { UserCognito } from "helpers";

export const useUser2FA = () => {
  const [user, setUser] = useState<UserCognito | undefined>(undefined);
  const [has2FA, setHas2FA] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const getUser = async () => {
      try {
        setIsLoading(true);
        const session = await fetchAuthSession();
        if (!session.tokens) {
          throw new Error("No authentication tokens available");
        }
        const payload = session.tokens.idToken?.payload;
        if (!payload) {
          throw new Error("Missing idToken payload");
        }

        const user: UserCognito = {
          username: (payload["cognito:username"] as string) || "",
          accessToken: session.tokens.accessToken?.toString() || "",
          idToken: session.tokens.idToken?.toString() || "",
          attributes: {
            sub: payload.sub as string,
            email: payload.email as string,
            phone_number: (payload.phone_number as string) || "",
            email_verified: payload.email_verified === true,
            phone_number_verified: payload.phone_number_verified === true,
          },
          preferredMFA: payload["cognito:preferred_mfa_setting"] === "SMS" ? "SMS_MFA" : "NOMFA",
        };

        setUser(user);
        setHas2FA(user.preferredMFA === "SMS_MFA");
        setError(null);
      } catch (err: any) {
        console.error("Error fetching user:", err);
        setError(err);
        setUser(undefined);
        setHas2FA(false);
      } finally {
        setIsLoading(false);
      }
    };

    getUser();
  }, []);

  return { user, has2FA, isLoading, error };
};
